// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ff7044ce395e2ec321a0","691":"5312ba9747f4e82e8c6c"}[chunkId] + ".js";
};